import styled from "styled-components";
export const ModalContent = styled.div `
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  height: ${props => props.height || 'auto'};
`;
